import React from "react";

export function Sparkline({ data, color = "hsl(var(--primary))", height = 56 }) {
  if (!data || data.length === 0) return null;
  const values = data.map((d) => (typeof d === "number" ? d : d.value ?? d.sessions ?? 0));
  const max = Math.max(...values, 1);
  const min = Math.min(...values, 0);
  const w = 200;
  const h = height;
  const step = w / Math.max(values.length - 1, 1);
  const norm = (v) => h - ((v - min) / (max - min || 1)) * (h - 6) - 3;
  const points = values.map((v, i) => `${i * step},${norm(v)}`).join(" ");
  const area = `M0,${h} L${points.split(" ").join(" L")} L${w},${h} Z`;
  return (
    <svg viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" width="100%" height={height} className="block">
      <defs>
        <linearGradient id="spark-grad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.25" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill="url(#spark-grad)" />
      <polyline points={points} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function BarChart({ data, height = 160, labelKey = "month", valueKey = "value", prefix = "" }) {
  if (!data || data.length === 0) return null;
  const max = Math.max(...data.map((d) => d[valueKey] || 0), 1);
  return (
    <div className="flex items-end gap-3 h-[160px] px-1">
      {data.map((d, i) => {
        const pct = Math.max(((d[valueKey] || 0) / max) * 100, 4);
        return (
          <div key={i} className="flex-1 flex flex-col items-center gap-2 group">
            <div className="w-full flex items-end justify-center relative" style={{ height: height - 28 }}>
              <div
                className="w-full max-w-[32px] rounded-md bg-gradient-to-t from-[hsl(var(--primary))] to-[hsl(var(--primary-hover))] transition-all group-hover:brightness-110"
                style={{ height: `${pct}%` }}
              />
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 text-[10px] font-mono font-semibold text-[hsl(var(--text))] opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                {prefix}{(d[valueKey] || 0).toLocaleString()}
              </div>
            </div>
            <div className="text-[10px] uppercase tracking-widest text-[hsl(var(--text-muted))]">{d[labelKey]}</div>
          </div>
        );
      })}
    </div>
  );
}
